import { Group, Paper, type PaperProps, Stack, Text } from '@mantine/core';
import { useHover, useId } from '@mantine/hooks';
import { IconArrowUpRight } from '@tabler/icons-react';
import { isDefined } from 'remeda';

interface TickerProps
  extends PaperProps,
    React.PropsWithChildren<{
      title?: React.ReactNode;
      topRight?: React.ReactNode;
      onClick?: () => void;
    }> {}

export const Ticker = ({ title, topRight, onClick, children }: TickerProps) => {
  const { hovered: isHovered, ref } = useHover();
  const titleId = useId();

  const isClickable = isDefined(onClick) && isHovered;

  return (
    <Paper
      ref={ref}
      component="section"
      aria-labelledby={titleId}
      style={{ cursor: isClickable ? 'pointer' : 'default', transition: 'all 0.1s ease-in-out' }}
      bg={isClickable ? 'purple.0' : 'white'}
      withBorder
      p="md"
      radius={16}
      onClick={onClick}
      h="100%"
    >
      <Stack justify="space-between" gap={0} h="100%">
        <Group mb="md" justify="space-between">
          <Group gap={4}>
            <Text id={titleId} size="xs" fw="bold" c="dimmed">
              {title}
            </Text>
            {isDefined(onClick) && <IconArrowUpRight size={16} stroke={1.5} />}
          </Group>
          {topRight && topRight}
        </Group>
        {children}
      </Stack>
    </Paper>
  );
};
